import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './index.css';

import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import PrestatairesPage from './pages/PrestatairesPage';
import ProfilePage from './pages/ProfilePage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import HowItWorksPage from './pages/HowItWorksPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import EditProfilePage from './pages/EditProfilePage';
import { DashboardClient } from './pages/DashboardClient';
import { DashboardPrestataire } from './pages/DashboardClient';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import { useAuthStore } from './store/authStore';
import AdminDashboard from './pages/AdminDashboard';
import ConditionsPage from './pages/ConditionsPage';
import ConfidentialitePage from './pages/ConfidentialitePage';
import FAQPage from './pages/FAQPage';
import AboutPage from './pages/AboutPage';
import InvoicePage from './pages/InvoicePage';
import PaymentSuccess from './pages/PaymentSuccess';
import './responsive.css';


function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

const ProtectedRoute = ({ children, role }) => {
  const { user, isAuthenticated } = useAuthStore();
  if (!isAuthenticated) return <Navigate to="/connexion" replace />;
  if (role && user?.role !== role) return <Navigate to="/" replace />;
  return children;
};

const AuthRequired = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  if (!isAuthenticated) return <Navigate to="/inscription" replace />;
  return children;
};

export default function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" toastOptions={{
        duration: 4000,
        style: { background: '#1A3B5D', color: '#fff', fontFamily: 'Inter, sans-serif', borderRadius: '8px' },
        success: { iconTheme: { primary: '#FF6B00', secondary: '#fff' } },
        error: { style: { background: '#EF4444' } },
      }} />
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/connexion" element={<LoginPage />} />
          <Route path="/inscription" element={<RegisterPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/comment-ca-marche" element={<HowItWorksPage />} />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/mot-de-passe-oublie" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/prestataires" element={<AuthRequired><PrestatairesPage /></AuthRequired>} />
          <Route path="/prestataires/:id" element={<AuthRequired><ProfilePage /></AuthRequired>} />
          <Route path="/services" element={<ServicesPage />} />          
          <Route path="/dashboard" element={<ProtectedRoute role="CLIENT"><DashboardClient /></ProtectedRoute>} />
          <Route path="/espace-prestataire" element={<ProtectedRoute role="PRESTATAIRE"><DashboardPrestataire /></ProtectedRoute>} />
          <Route path="/mon-profil/edit" element={<ProtectedRoute role="PRESTATAIRE"><EditProfilePage /></ProtectedRoute>} />
          <Route path="/facture/:id" element={<ProtectedRoute><InvoicePage /></ProtectedRoute>} />
          <Route path="/paiement/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
          <Route path="/conditions" element={<ConditionsPage />} />
          <Route path="/confidentialite" element={<ConfidentialitePage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/qui-sommes-nous" element={<AboutPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </main>
      <Footer />
    </BrowserRouter>
  );
}
